import React from "react";
import {
  Box,
  Paper,
  Typography,
  Chip,
  Divider,
  IconButton,
  Tooltip,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";

export default function AssignmentInfoCard({ assignment }) {
  if (!assignment) {
    return (
      <Paper
        elevation={0}
        sx={{
          p: 2,
          mt: 2,
          bgcolor: "#fff8e1",
          border: "1px solid #ffe082",
          borderRadius: 2,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          ⏳ Awaiting driver assignment. We'll notify you once a driver is assigned.
        </Typography>
      </Paper>
    );
  }

  const { vendor, pickupTime, status, notes } = assignment;

  const getStatusColor = () => {
    switch (status) {
      case "ASSIGNED":
        return "primary";
      case "EN_ROUTE":
        return "warning";
      case "PICKED_UP":
        return "info";
      case "COMPLETED":
        return "success";
      case "CANCELLED":
        return "error";
      default:
        return "default";
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mt: 2,
        borderLeft: 4,
        borderColor: "success.main",
        bgcolor: "#f1f8e9",
        borderRadius: 2,
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="subtitle1" fontWeight="bold">
          🚗 Your Driver Details
        </Typography>
        <Chip label={status} color={getStatusColor()} size="small" />
      </Box>

      <Divider sx={{ mb: 1.5 }} />

      <Box display="flex" flexDirection="column" gap={1}>
        <Box display="flex" alignItems="center" gap={1}>
          <PersonIcon fontSize="small" color="action" />
          <Typography variant="body2">
            <strong>{vendor.vendorName}</strong>
          </Typography>
        </Box>

        <Box display="flex" alignItems="center" gap={1}>
          <PhoneIcon fontSize="small" color="action" />
          <Typography variant="body2">{vendor.contactNumber}</Typography>
          <Tooltip title="Call driver">
            <IconButton
              size="small"
              color="primary"
              component="a"
              href={`tel:${vendor.contactNumber}`}
            >
              <PhoneIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>

        {vendor.vehicleNumber && (
          <Box display="flex" alignItems="center" gap={1}>
            <DirectionsCarIcon fontSize="small" color="action" />
            <Typography variant="body2">{vendor.vehicleNumber}</Typography>
          </Box>
        )}

        {pickupTime && (
          <Box display="flex" alignItems="center" gap={1}>
            <AccessTimeIcon fontSize="small" color="action" />
            <Typography variant="body2">
              Pickup time: <strong>{pickupTime}</strong>
            </Typography>
          </Box>
        )}

        {notes && (
          <Box mt={1} p={1} bgcolor="grey.100" borderRadius={1}>
            <Typography variant="caption" color="text.secondary">
              <strong>Note from admin:</strong> {notes}
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
}